import React from 'react';
import PropTypes from 'prop-types';
import PlayIcon from 'mdi-react/YoutubePlayIcon';
import { bemGenerator } from '@prisjakt/ui-base';

import './video-thumbnail.scss';

const styles = bemGenerator('pj-ui-carousel-video-thumbnail', ['play-icon']);

const VideoThumbnail = props => (
  <div className={styles.block}>
    <div className={styles['play-icon']}>
      <PlayIcon />
    </div>
    <img src={props.src} alt="" />
  </div>
);

const { string } = PropTypes;

VideoThumbnail.propTypes = {
  src: string.isRequired,
};

export default VideoThumbnail;
